
import React from 'react';
import { CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Globe, Lock, Pencil, Trash2, Users } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { User } from 'lucide-react';

interface PlaylistCardHeaderProps {
  name: string;
  description?: string | null;
  city?: string | null;
  isPublic?: boolean;
  canEdit: boolean;
  isOwner: boolean;
  isAuthenticated: boolean;
  isFollowing?: boolean | null;
  followersCount?: number;
  creatorName?: string | null;
  creatorAvatar?: string | null;
  onEdit: () => void;
  onDelete: () => void;
  onFollow: () => void;
}

export const PlaylistCardHeader: React.FC<PlaylistCardHeaderProps> = ({
  name,
  description,
  city,
  isPublic = true,
  canEdit,
  isOwner,
  isAuthenticated,
  isFollowing,
  followersCount = 0,
  creatorName,
  creatorAvatar,
  onEdit,
  onDelete,
  onFollow,
}) => {
  return (
    <CardHeader className="pb-3">
      <div className="flex items-center justify-between">
        <CardTitle className="flex items-center gap-2">
          {name}
          {isPublic ? (
            <Globe className="w-4 h-4 text-muted-foreground" />
          ) : (
            <Lock className="w-4 h-4 text-muted-foreground" />
          )}
        </CardTitle>
        <div className="flex items-center gap-2">
          {isAuthenticated && !isOwner && (
            <Button
              variant="ghost"
              size="sm"
              className="flex items-center gap-1"
              onClick={(e) => {
                e.stopPropagation();
                onFollow();
              }}
            >
              <Users className="w-4 h-4" />
              {isFollowing ? 'Unfollow' : 'Follow'}
            </Button>
          )}
          {canEdit && isAuthenticated && (
            <div className="flex gap-2">
              <Button 
                variant="ghost" 
                size="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit();
                }}
              >
                <Pencil className="w-4 h-4" />
              </Button>
              <Button 
                variant="ghost" 
                size="icon" 
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          )}
        </div>
      </div>
      <CardDescription>
        {description}
        {city && (
          <div className="mt-1 text-sm">📍 {city}</div>
        )}
        <div className="mt-1 text-sm flex items-center gap-1">
          <Users className="w-4 h-4" />
          {followersCount || 0} followers
        </div>
        {creatorName && (
          <div className="mt-1 text-sm flex items-center gap-1">
            <Avatar className="h-4 w-4">
              <AvatarImage src={creatorAvatar || ''} />
              <AvatarFallback><User className="w-2 h-2" /></AvatarFallback>
            </Avatar>
            <span>By {creatorName}</span>
          </div>
        )}
      </CardDescription>
    </CardHeader>
  );
};
